import * as React from "react";

import { default as LogResultEditor } from "./LogResultEditor";
import { default as ParameterInput } from "./ParameterInput";

export const WhileEditor: React.FC<WhileProps> = (props) => {
    return (<div>
        <ParameterInput name="expression" label={FRENDS.Localizations.Expression} elementId={props.id} value={props.existingParameters["expression"]} />
        <ParameterInput name="maxIterations" label={FRENDS.Localizations.MaxIterations} elementId={props.id} value={props.existingParameters["maxIterations"] || { mode: "integer", value: "10000" }} min={1} max={2147483647} />
        <LogResultEditor elementId={props.id} />
    </div>
    );
};

interface WhileProps {
    id: string;
    existingParameters: any;
}
